import React from 'react';

import { Text } from '@change/ds-core-ui';

import { useLocalStats } from './hooks/useLocalStats';

export const LocalStats: React.FC = () => {
	const {
		data: { signatureCountLabel, totalVictoriesLabel },
	} = useLocalStats();

	return (
		<ul className="m-0 list-inside list-disc space-y-2 p-0">
			<Text variant="body" as="li" className="text-typography-strong">
				{signatureCountLabel}
			</Text>
			<Text as="li" className="text-typography-strong">
				{totalVictoriesLabel}
			</Text>
		</ul>
	);
};
